import { render, staticRenderFns } from "./SmartArticleList.vue?vue&type=template&id=767d0fed&scoped=true"
import script from "./SmartArticleList.vue?vue&type=script&lang=js"
export * from "./SmartArticleList.vue?vue&type=script&lang=js"
import style0 from "./SmartArticleList.vue?vue&type=style&index=0&id=767d0fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d0fed",
  null
  
)

export default component.exports